<script>
import {formatMoney} from "../../../../../components/admin/filters";

export default {
  name: "ConsolidatedFlowTableButton",
  props: {
    structuredLenderId: {
      type: Number,
      default: 0
    }
  },
  data: () => ({
    showDialog: false,
    consolidatedCommissions: []
  }),
  methods: {
    formatMoney,
    async fetchConsolidatedFlow() {
      this.$vs.loading();
      try {
        const {data} = await axios.get(`/api/backoffice/treasury/trust-management/structured-lender/${this.structuredLenderId}/consolidated-flow`);
        this.consolidatedCommissions = data;
        this.$vs.loading.close();
      } catch (e) {
        this.$vs.loading.close();
        this.$vs.notify({
          title: "Error",
          text: "Ocurrió un error al cargar las comisiones consolidadas",
          color: "danger"
        });
      }
    },
    async showDialogHandler() {
      this.showDialog = !this.showDialog;
      await this.fetchConsolidatedFlow();
    }
  }
}
</script>

<template>
<div>
  <vs-button
      @click="showDialogHandler"
      size="small"
      color="black"
      class="uppercase">
    Tabla consolidad flujo
  </vs-button>

  <vs-popup fullscreen title="Tabla de comisiones consolidada" :active.sync="showDialog">
    <vs-table stripe :data="consolidatedCommissions">
      <template v-slot:thead>
        <vs-th>Periodo</vs-th>
        <vs-th>Amortización</vs-th>
        <vs-th>Interés</vs-th>
        <vs-th>Comisión</vs-th>
        <vs-th>IVA</vs-th>
      </template>
      <template scope="{data}">
        <vs-tr v-for="commission in data">
          <vs-td>{{ commission.period }}</vs-td>
          <vs-td>{{ formatMoney(commission.rg_amortization) }}</vs-td>
          <vs-td>{{ formatMoney(commission.rg_interest) }}</vs-td>
          <vs-td>{{ formatMoney(commission.rg_client_commission) }}</vs-td>
          <vs-td>{{ formatMoney(commission.rg_tax) }}</vs-td>
        </vs-tr>
      </template>
    </vs-table>
  </vs-popup>
</div>
</template>

<style scoped>

</style>